import {Injectable} from '@angular/core';
import {LicenseApiService} from '../../api/settings/administration/license/license-api.service';
import {Observable, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LicenseFeaturesService {

  license: any = null;

  constructor(private licenseApiService: LicenseApiService) {
  }

  refresh(): any {
    this.licenseApiService.getLicense().subscribe((license) => {
      this.license = license;
    });
  }

  isFeatureSupported(featureName): Observable<boolean> {
    if (this.license === null) {
      return this.licenseApiService.getLicense().pipe(mergeMap(l => {
        this.license = l;
        return of(this.checkIsFeatureSupported(featureName));
      }));
    } else {
      return of(this.checkIsFeatureSupported(featureName));
    }
  }

  reset(): void {
    this.license = null;
  }

  private checkIsFeatureSupported(featureName): boolean {
    if (this.license.licenseExists) {
      return this.license.licenseFeatures[featureName] === undefined ||
        this.license.licenseFeatures[featureName].value > 0;
    }

    return false;
  }
}
